import SignIn from "./sign-in.page";

export default SignIn;
